/**
 * Objective definitions for the @-mention catalog (the Objectives group in
 * MentionEditor). Fetched per-tab like org users are — the builder tabs are
 * self-sufficient about their mention data sources.
 *
 * ObjectivesTab does NOT use this hook: it already holds the live definitions
 * in state and passes those directly, so its catalog reflects unsaved edits.
 */

import { useEffect, useState } from 'react';
import useApi from '../../api';
import { MentionableObjective } from './promptMentions';

export default function useObjectiveMentions(agId?: string): MentionableObjective[] {
  const { get } = useApi();
  const [objectives, setObjectives] = useState<MentionableObjective[]>([]);

  useEffect(() => {
    if (!agId) return;
    let cancelled = false;
    get(`/agents/${agId}/objectives`)
      .then((response) => {
        if (cancelled) return;
        const items = response.data?.items || [];
        setObjectives(
          items
            .filter((item: any) => item?.key && item?.active !== false)
            .map((item: any) => ({ key: item.key, name: item.name }))
        );
      })
      .catch((error) => {
        // Mentions degrade gracefully without the catalog; don't surface.
        console.error('Error fetching objectives for mentions:', error);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agId]);

  return objectives;
}
